import background from "../assets/edc-background.png";

export const styles = {
  root: {
    backgroundColor: "#fff8f1",
    backgroundImage: `url(${background})`,
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    width: "100%",
    height: "100vh",
    display: "flex",
    flexDirection: "row",
    alignItems: "safe center",
    overflowY: "auto",
    justifyContent: "center",
  },
  container: {
    background: "#fff",
    borderRadius: "5px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    border: "1px solid #e8e8e8",
    boxShadow: "-2px 2px 40px #0000000d",
    width: "500px",
    textAlign: "center",
    padding: "60px 40px",
    "@media (max-width: 600px)": {
      width: "340px",
      padding: "24px",
    },
  },
  logo: {
    // width: "80px",
    // height: "80px",
    marginBottom: "40px",
    "@media (max-width: 600px)": {
      width: "250px",
      marginBottom: "16px",
    },
  },
  header: {
    fontFamily: "DM Sans, Helvetica, Arial, sans-serif",
    fontSize: "20px",
    lineHeight: "28px",
    fontWeight: "500",
    marginBottom: "8px",
  },
  description: {
    fontFamily: "DM Sans, Helvetica, Arial, sans-serif",
    marginTop: "20px",
    fontSize: "14px",
    lineHeight: "18px",
    fontWeight: "400",
  },
  button: {
    marginTop: "24px",
    borderRadius: "20px !important",
    backgroundColor: "#0C3891 !important",
    height: "40px !important",
    fontSize: "16px !important",
    fontWeight: "700 !important",
  },
};
